import { get, set, del } from 'idb-keyval';
import type { LibraryFile, LibraryRoom } from './types';

const LIB_KEY = 'md:library:v1';
const docKey = (id: string) => `md:doc:${id}`;

export interface LibraryShape {
  files: LibraryFile[];
  rooms: LibraryRoom[];
}

export async function loadLibrary(): Promise<LibraryShape> {
  const v = (await get(LIB_KEY)) as LibraryShape | undefined;
  return v ?? { files: [], rooms: [] };
}

export async function saveLibrary(lib: LibraryShape): Promise<void> {
  await set(LIB_KEY, lib);
}

export async function loadDoc(id: string): Promise<string> {
  const v = (await get(docKey(id))) as string | undefined;
  return v ?? '';
}

export async function saveDoc(id: string, content: string): Promise<void> {
  await set(docKey(id), content);
}

export async function deleteDoc(id: string): Promise<void> {
  await del(docKey(id));
}

export function uid(): string {
  return Math.random().toString(36).slice(2, 10);
}
